import getStore from 'services/getStore';

const getModuleImages = () => {
  const images = [] as string[];

  // will fix this up later
  let blocks = getStore().getState().blocks as any; // blocks;

  Object.values(blocks).forEach((b: any, index: number) => {
    const { props } = b || {};

    // work in progress
    // wants to some recursive function
    const values = Object.values({
      ...props,
      ...(props?.style || {}),
      ...(props?.topicIcon || {}),
    });

    values.forEach((entry: any) => {
      if (entry && typeof entry === 'string') {
        let extension: string[] | string = entry?.split(/\./g);
        extension =
          extension.length > 1
            ? extension[extension.length - 1].toLowerCase()
            : '';

        if (
          ['png', 'jpg', 'jpeg', 'gif', 'svg'].includes(extension) &&
          !entry.match(/@editor|\/creator\//g)
        ) {
          images.push(entry);
        }
      }
    });
  });

  const imagesWithoutDuplicates: any[] = Array.from(new Set(images));

  // console.log('module images : \n _');
  // imagesWithoutDuplicates.forEach(i => console.log(i));
  // console.log('_');

  return imagesWithoutDuplicates;
};

export default getModuleImages;
